import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"minus\"><path d=\"M16 192h480c8.848 0 16 7.168 16 16v96c0 8.848-7.152 16-16 16H16c-8.832 0-16-7.152-16-16v-96c0-8.832 7.168-16 16-16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/minus.svg
// module id = QT2L
// module chunks = 1